module.exports = __webpack_public_path__ + "static/img/zhizhao.90da040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhizhao.png
// module id = QpgX
// module chunks = 21